import { NgModule } from '@angular/core';
import { DocPipe } from './doc.pipe';
import { TextCasePipe } from './text-case.pipe';

@NgModule({
  declarations: [
    DocPipe,
    TextCasePipe
  ],
  imports: [
  ],
  providers: [
  ],
  bootstrap: [],
  exports: [
    DocPipe,
    TextCasePipe
  ]
})
export class PipesModule {}
